import { api } from "./api";
import secureStorage from "utils/secureStorage";

const KEY_CLIENT = "@cliente";
const KEY_AUTHOR = "AUTHOR_ID";

export const setClient = (client) => {
  secureStorage.setJson(KEY_CLIENT, client);
  if (client?.user?.id) {
    secureStorage.setItem(KEY_AUTHOR, String(client.user.id));
  }
  if (client?.token) {
    secureStorage.setToken(client.token);
    api.defaults.headers.common.Authorization = `Token ${client.token}`;
  }
};

export const clearClient = () => {
  secureStorage.clearJson(KEY_CLIENT);
  secureStorage.removeItem(KEY_AUTHOR);
  secureStorage.removeToken();
  delete api.defaults.headers.common.Authorization;
};

export const getStoredClient = () => secureStorage.getJson(KEY_CLIENT);

export const getAuthorId = () => secureStorage.getItem(KEY_AUTHOR);

export const signIn = (client) => {
  setClient(client);
};

export const signOut = () => {
  clearClient();
};

export const isSignedIn = () => {
  const client = getStoredClient();
  if (client?.token) {
    api.defaults.headers.common.Authorization = `Token ${client.token}`;
    return true;
  }
  return false;
};
